<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="wrapper">
				<div class="container">
					<div class="body">
						<div class="body__title">
							<h1 class="body__title-text">Resetar Senha</h1>
						</div>
						<div class="body__description">
							<p class="body__description-text">
								Para resetar a senha deste usuário pelo admin, crie uma nova senha, que será a única
								e principal senha do usuário.
							</p>
						</div>
					</div>
					<div class="detail">
						<div class="detail-form">
							<div class="detail-form--items">
								<label class="detail-form--items__label">Senha:</label>
								<InfoPasswordTooltip :password="password"></InfoPasswordTooltip>
							</div>
							<InputPassword
								id="password-input"
								v-model="password"
								class="detail-form--input"
								:class="(validatedPasswords && password) || !password ? 'approved' : 'deny'"
								:alertClass="password"
								@clearRequired="requiredFields.password = false"
							/>
							<small class="detail-form--input--required" v-if="requiredFields.password">
								Campo obrigatório.
							</small>
						</div>
						<div class="detail-form">
							<div class="detail-form--items">
								<label class="detail-form--items__label" for="confirm_password"
									>Confirmar Senha:</label
								>
								<InfoPasswordTooltip :confirmPassword="confirmPassword"></InfoPasswordTooltip>
							</div>
							<InputPassword
								id="password-input"
								v-model="confirmPassword"
								class="detail-form--input"
								:class="
									(validatedPasswords && confirmPassword) || !confirmPassword ? 'approved' : 'deny'
								"
								:alertClass="confirmPassword"
								@clearRequired="requiredFields.confirmPassword = false"
							/>
							<small class="detail-form--input--required" v-if="requiredFields.confirmPassword">
								Campo obrigatório.
							</small>
						</div>
					</div>

					<div class="actions">
						<button id="action-btn" class="actions__btn outline" @click="handleNewPasswordModal()">
							Cancelar
						</button>
						<button
							id="action-btn"
							class="actions__btn"
							:class="isLoadingUsers ? 'disabled' : ''"
							@click="validateFields()"
						>
							<span v-if="!isLoadingUsers">Confirmar</span>
							<SpinnerIcon :color="'white'" v-else />
						</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex';
import CloseIcon from '@/components/shared/Icons/CloseIcon.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import InfoPasswordTooltip from '@/components/modules/User/UserDetail/InfoPasswordTooltip/InfoPasswordTooltip.vue';
import InputPassword from '@/components/shared/InputPassword/InputPassword.vue';

export default {
	name: 'NewPasswordModal',
	components: { CloseIcon, SpinnerIcon, InputPassword, InfoPasswordTooltip },
	props: {},
	data: () => ({
		password: '',
		confirmPassword: '',
		requiredFields: {
			password: false,
			confirmPassword: false,
		},
	}),
	mounted() {},
	methods: {
		handleNewPasswordModal() {
			this.$emit('handleNewPasswordModal');
		},
		validatedPasswords() {
			return this.$refs.passwordRules.validatedPasswords();
		},
		validateFields() {
			if (!this.password) return (this.requiredFields.password = true);
			if (!this.confirmPassword) return (this.requiredFields.confirmPassword = true);

			if (this.password) this.requiredFields.password = false;
			if (this.confirmPassword) this.requiredFields.confirmPassword = false;

			if (this.password != this.confirmPassword)
				return this.$toastr.e('As senhas precisam ser iguais.');

			this.$emit('updateUserPassword', this.password);
			this.$emit('validateFields');
			this.handleNewPasswordModal();
		},
	},
	computed: {
		...mapGetters('userManagement', ['isLoadingUsers']),
	},
};
</script>

<style lang="scss" scoped>
@import 'NewPasswordModal.scss';
</style>
